module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "bkloading",
      rawName: "v-bkloading",
      value: ({
        isLoading: _vm.initLoading
      }),
      expression: "{isLoading: initLoading}"
    }],
    staticClass: "honor-rules"
  }, [_vm._m(0), _vm._v(" "), _c('section', {
    staticClass: "honor-wrapper"
  }, [_c('div', {
    staticClass: "honor-content"
  }, [_c('img', {
    staticClass: "title",
    attrs: {
      "src": require("../images/honor_system/h1-1.png")
    }
  }), _vm._v(" "), _c('ul', {
    staticClass: "honor-list"
  }, _vm._l((_vm.communityHonorList), function(item, index) {
    return _c('li', {
      key: index,
      staticClass: "honor-item"
    }, [(item.is_user_get) ? _c('img', {
      staticClass: "honor-img",
      attrs: {
        "src": item.icon_on,
        "alt": ""
      }
    }) : _c('img', {
      staticClass: "honor-img",
      attrs: {
        "src": item.icon_off,
        "alt": ""
      }
    }), _vm._v(" "), _c('p', {
      staticClass: "honor-time mr-auto"
    }, [_vm._v(_vm._s(item.name.split('-')[0]))]), _vm._v(" "), _c('p', {
      staticClass: "honor-title"
    }, [_vm._v(_vm._s(item.name.split('-')[1]))]), _vm._v(" "), _c('p', {
      staticClass: "honor-name mr-auto"
    }, [_vm._v(_vm._s(item.is_user_get ? _vm.userInfo.name : '请加油'))]), _vm._v(" "), _c('p', {
      staticClass: "honor-nums"
    }, [_c('span', {
      staticStyle: {
        "margin-right": "12px"
      }
    }, [_vm._v(_vm._s(_vm.matchHonor(item.name.split('-')[1])))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(item.total_get_count) + " 人已获得")])])])
  }), 0)])]), _vm._v(" "), _c('section', {
    staticClass: "growth-wrapper"
  }, [_c('div', {
    staticClass: "growth-content"
  }, [_c('img', {
    staticClass: "title",
    attrs: {
      "src": require("../images/honor_system/h1-2.png")
    }
  }), _vm._v(" "), _c('ul', {
    staticClass: "growth-list"
  }, _vm._l((_vm.growthList), function(info, index) {
    return _c('li', {
      key: index,
      staticClass: "growth-item",
      style: ({
        'marginRight': ((index < 3 ? (179 + 11*index) : 0) + "px")
      })
    }, [_c('img', {
      staticClass: "medal-icon",
      attrs: {
        "src": (!_vm.userInfo.user_id || info.is_user_get) ? info.icon_on : info.icon_off,
        "alt": ""
      }
    }), _vm._v(" "), _c('div', {
      class: ['milestone', {
        'active': info.is_user_get
      }]
    }), _vm._v(" "), _c('p', {
      staticClass: "name"
    }, [_vm._v(_vm._s(info.name))]), _vm._v(" "), _c('p', {
      staticClass: "desc"
    }, [_vm._v(_vm._s(info.desc))])])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "growth-progress"
  }, [_c('div', {
    class: ['bar', {
      'is-init': _vm.isInit
    }],
    style: ({
      width: _vm.percentage
    }),
    on: {
      "mouseleave": function($event) {
        _vm.isInit = false
      }
    }
  }, [(_vm.userInfo.user_id && !_vm.growthList[3].is_user_get) ? _c('div', {
    staticClass: "growth-bar-pop"
  }, [_vm._v("\n                        " + _vm._s(("当前位置，还差 " + _vm.remainderDays + " 天即可解锁")) + "\n                    ")]) : _vm._e()])])])]), _vm._v(" "), _c('section', {
    staticClass: "identity-wrapper"
  }, [_c('div', {
    staticClass: "identity-content"
  }, [_c('img', {
    staticClass: "title",
    attrs: {
      "src": require("../images/honor_system/h1-3.png")
    }
  }), _vm._v(" "), _c('ul', {
    staticClass: "identify-list"
  }, _vm._l((_vm.identifyList), function(info, index) {
    return _c('li', {
      key: index
    }, [_c('div', {
      staticClass: "left-medal"
    }, [_c('img', {
      attrs: {
        "src": (!_vm.userInfo.user_id || info.is_user_get) ? info.icon_on : info.icon_off,
        "alt": ""
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "right-box"
    }, [_c('div', {
      staticClass: "right-top"
    }, [_c('span', {
      staticClass: "medal-name"
    }, [_vm._v(_vm._s(info.name))]), _vm._v(" "), _c('span', {
      staticClass: "have-tasks"
    }, [_vm._v(_vm._s(info.total_get_count) + "人获得")])]), _vm._v(" "), _c('div', {
      staticClass: "medal-desc"
    }, [_vm._v(_vm._s(info.desc))])])])
  }), 0)])]), _vm._v(" "), _c('section', {
    staticClass: "competition-wrapper"
  }, [_c('div', {
    staticClass: "competition-content"
  }, [_c('img', {
    staticClass: "title",
    attrs: {
      "src": require("../images/honor_system/h1-4.png")
    }
  }), _vm._v(" "), _c('ul', {
    staticClass: "competition-list"
  }, _vm._l((_vm.competitionList), function(item) {
    return _c('li', {
      key: item.id
    }, [_c('div', {
      staticClass: "competition-label"
    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('ul', {
      staticClass: "competition-rank"
    }, _vm._l((item.medal), function(info) {
      return _c('li', {
        key: info.id,
        class: ['rank-item', {
          'is-active': info.is_user_get
        }]
      }, [_c('img', {
        staticClass: "medal-icon",
        attrs: {
          "src": (!_vm.userInfo.user_id || info.is_user_get) ? info.icon_on : info.icon_off,
          "alt": ""
        }
      }), _vm._v(" "), (info.year) ? _c('div', {
        staticClass: "award-years"
      }, [_c('span', {
        staticClass: "date"
      }, [_vm._v(_vm._s(info.year))])]) : _vm._e()])
    }), 0)])
  }), 0)])]), _vm._v(" "), _c('section', {
    staticClass: "community-wrapper"
  }, [_c('div', {
    staticClass: "community-content"
  }, [_c('img', {
    staticClass: "title",
    attrs: {
      "src": require("../images/honor_system/H1-5.png")
    }
  }), _vm._v(" "), _c('ul', {
    staticClass: "zone-list"
  }, _vm._l((_vm.communityList), function(item) {
    return _c('li', {
      key: item.id
    }, [_c('div', {
      staticClass: "zone-label"
    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _vm._l((item.medal), function(info) {
      return _c('div', {
        key: info.id,
        staticClass: "content-item"
      }, [_c('div', {
        staticClass: "left-medal"
      }, [_c('img', {
        attrs: {
          "src": (!_vm.userInfo.user_id || info.is_user_get) ? info.icon_on : info.icon_off,
          "alt": ""
        }
      })]), _vm._v(" "), _c('div', {
        staticClass: "right-box"
      }, [_c('div', {
        staticClass: "right-top"
      }, [_c('span', {
        staticClass: "medal-name"
      }, [_vm._v(_vm._s(info.name))]), _vm._v(" "), _c('span', {
        staticClass: "have-tasks"
      }, [_vm._v(_vm._s(info.total_get_count + '人获得'))])]), _vm._v(" "), _c('div', {
        staticClass: "medal-desc"
      }, [_vm._v(_vm._s(info.desc))])])])
    })], 2)
  }), 0)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "banner"
  }, [_c('img', {
    staticClass: "medal-bg",
    attrs: {
      "src": require("../images/honor_system/medal.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "contents"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v("蓝鲸社区荣誉勋章")]), _vm._v(" "), _c('p', {
    staticClass: "desc"
  }, [_vm._v("勋章是蓝鲸用户在蓝鲸社区进行活跃互动的奖励，是社区参与度的直接体现")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-6ed85429!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/honorRules.vue
// module id = hH20
// module chunks = 15